import NewDetailBanner from "./NewDetailBanner";
import Contact from "../Contact/Contact";
import NewDetailBody from "./NewDetailBody";

export default function NewDetail() {
  return (
    <div>
      <NewDetailBanner />
      <NewDetailBody />
      <Contact />
    </div>
  );
}
